import { render, staticRenderFns } from "./HelpAmount.vue?vue&type=template&id=64425012&scoped=true&"
import script from "./HelpAmount.vue?vue&type=script&lang=js&"
export * from "./HelpAmount.vue?vue&type=script&lang=js&"
import style0 from "./HelpAmount.vue?vue&type=style&index=0&id=64425012&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64425012",
  null
  
)

export default component.exports